import moment from 'moment-timezone';
import { AccountProps } from 'services/hooks/account-service';
import { BuildingProps } from 'services/hooks/building-service';
import { OrganizationProps } from 'services/hooks/organization-service';

export const GetOccupantDefaultValues = (
  userRole: string | undefined,
  accountData: AccountProps | undefined,
  orgData: OrganizationProps | undefined,
  buildingData: BuildingProps | undefined,
  buildingTimezone: string
) => {
  const defaultValues: any = {
    uuid: '',
    phoneNumber: '',
    firstName: '',
    lastName: '',
    isVisitor: false,
    organizationUuid: '',
    buildingUuid: '',
    accountUuid: '',
    credentialId: '',
    cards: [],
    fcmToken: '',
    format: '',
    badgeId: '',
    facilityCode: '',
    description: '',
    integrationUuid: '',
    latchIntegrationUuid: '',
    email: '',
    startTime: new Date(),
    endTime: new Date(),
    doorIds: [],
    startDate: moment.tz(new Date(), buildingTimezone).toDate(),
    endDate: moment.tz(new Date(), buildingTimezone).toDate(),
    assaCardType: '',
    assaGuestCardType: '',
    lostPhoneId: ''
  };

  switch (userRole) {
    case 'SUPER':
      break;

    case 'ACCOUNT':
      if (accountData) {
        defaultValues.accountUuid = accountData.uuid;
      }
      break;

    case 'BUILDING':
      if (buildingData) {
        defaultValues.buildingUuid = buildingData.uuid;
        defaultValues.accountUuid = buildingData.accountUuid;
      }
      break;

    case 'ORG':
      if (orgData) {
        defaultValues.organizationUuid = orgData.uuid;
        defaultValues.buildingUuid = orgData.buildingUuid;
        defaultValues.accountUuid = buildingData?.accountUuid;
      }
      break;

    default:
      break;
  }

  return defaultValues;
};
